import type { Maybe } from '@adornis/base/utilTypes.js';
import { webcomponent } from '@adornis/functional-lit/webcomponent.js';
import { XEntityVersionPatchList } from '@adornis/versioned-entity/client/x-entity-version-patch-list.js';
import type { EntityPatch, SinglePatch } from '@adornis/versioned-entity/entities/entity-patches.js';

export const ChromiumEntityVersionPatchList = webcomponent(
  'cr-entity-version-patch-list',
  (
    params: {
      referenceIDs?: string[];
      filterPatches?: Maybe<(patch: EntityPatch) => boolean>;
      filterSinglePatches?: Maybe<(singlePatch: SinglePatch) => boolean>;
      formatValue?: Maybe<(val: any, path: SinglePatch) => string>;
      useAuthorName?: boolean;
      collectionName?: string;
      maxVisibleChanges?: number;
      changeStringParsing?: (changeString: string) => string;
    } = {},
  ) => {
    return XEntityVersionPatchList(params);
  },
  // `XEntityVersionPatchList` is styled entirely with Tailwind/daisyUI classes. Without its own
  // shadow root this renders into the light DOM, i.e. into whichever shadow root happens to contain
  // it — and every chemistry `x-*` component (all 60 of them) still extends the non-Tailwind
  // `chemistry-lit-element`, whose shadow root never adopts the Tailwind sheet. Inside
  // `cr-nospace-toggle-content` that left the change history as unstyled text with a literal
  // "chevron_right" where the icon should be. Giving it its own shadow root makes `webcomponent`
  // adopt the Tailwind sheet (it does so by default unless `dontAdoptTailwindStyleSheet` is set),
  // so the component is styled regardless of what it is nested in.
  // TODO: fix properly by porting properly
  { shadowRoot: true },
);
